/**
 * ToastContainer.tsx - Container for managing multiple toasts
 * 
 * CHANGE HISTORY:
 * - 251025_1600 [pending] danielbeer: Initial creation
 * 
 * Manages positioning and rendering of multiple toast notifications
 */

import React from 'react';
import { Toast } from './Toast';
import { ToastConfig, ToastPosition } from '../types';
import './ToastContainer.css';

export interface ToastItem extends ToastConfig {
  id: string;
}

export interface ToastContainerProps {
  toasts: ToastItem[];
  position?: ToastPosition;
  onDismiss: (id: string) => void;
}

/**
 * ToastContainer - Manages multiple toast notifications
 * 
 * Features:
 * - Configurable position (top/bottom, left/center/right)
 * - Stacks toasts vertically
 * - Auto-dismiss support
 */
export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  position = 'top-right',
  onDismiss
}) => {
  if (toasts.length === 0) return null;

  return (
    <div className={`promptr-toast-container promptr-toast-container-${position}`}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onDismiss={onDismiss}
        />
      ))}
    </div>
  );
};
